import * as React from 'react';
import { connect } from 'react-redux';
import Loader from 'components/Common/Loader/Loader';
import * as asyncHelper from 'utils/asyncStatusHelper';
import StringWidget from 'components/StringWidget';
import { get } from 'lodash';
import { TNC_URL, fetchKnowMoreAction } from 'actions/CartActions/BuyBackTnCActions';
import styles from './BuyBackTnC.css';
class DeferredContent extends React.Component {
    UNSAFE_componentWillMount() {
        const { params, fetchContent } = this.props;
        params && fetchContent({ params });
    }
    render() {
        const { response } = this.props;
        if (!response) {
            return null;
        }
        // Loader and the error message are picked up from deferred content
        // component
        switch (response.asyncStatus) {
            case asyncHelper.LOADING:
                return <Loader />;
            case asyncHelper.SUCCESS:
                const title = get(response, 'content.ctaTitle', '');
                const checkList = get(response, 'content.exchangeViewResponse.checkList', []);
                if (!title || !checkList || !checkList.length)
                    return null;
                return (<React.Fragment>
						<p>
							<strong>{title}</strong>
						</p>
						<ol className={styles['list']}>
							{checkList.map((desc, idx) => {
                    return (<li key={idx} className={styles['list-item']}>
										{desc}
									</li>);
                })}
						</ol>
					</React.Fragment>);
            case asyncHelper.ERROR:
                return <StringWidget strKey="errortnc"/>;
            default:
                return null;
        }
    }
}
function mapStateToProps(state) {
    return {
        response: get(state.deferredContent, ['data', TNC_URL], {})
    };
}
const mapDispatchToProps = {
    fetchContent: fetchKnowMoreAction
};
export const KnowMoreContent = connect(mapStateToProps, mapDispatchToProps)(DeferredContent);
